<template>
  <el-dialog
    title="查看预估详情"
    :visible.sync="isShow"
    :before-close="handleClose"
    width="50%"
    :close-on-click-modal="false"
    style="font-size:14px; "
  >
    <div>
      <span style="line-height: 32px">请选择日期：</span>
      <el-date-picker
        v-model="time"
        type="daterange"
        range-separator="~"
        value-format="yyyy-MM-dd"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <el-button type="primary" @click="queryData" style="margin: 0 8px"
      >
        搜索
      </el-button>
      <el-button @click="resetSearch">重置</el-button>
    </div>
    <div class="total-global ">
      <div>
        <span class="el-icon-warning total-title"></span>
        <span class="total-desc">合计(本页/全部):</span>
        <span class="total-label">{{ type == 263 ? "预估订单额:" : "预估数据:" }}</span><span
        class="total-value">{{ moneyTrans(totalMoney.currentData) }}<span
        class="total-line">/</span>{{ moneyTrans(total.additional.estimateDataSum) }}</span>
        <span class="total-label">预估佣金:</span><span class="total-value">{{ moneyTrans(totalMoney.currentMoney) }}<span
        class="total-line">/</span>{{ moneyTrans(total.totalAmount) }}</span>
      </div>
    </div>
    <el-table
      :key="tableKey"
      ref="multipleTable"
      v-loading="listLoading"
      stripe
      :data="list"
      tooltip-effect="dark"
      style="width: 100%"
    >
      <el-table-column
        :show-overflow-tooltip="true"
        label="日期"
        min-width="100px"
      >
        <template slot-scope="scope">
          <span>{{ emptyDeal(scope.row.dataDate) }}</span>
        </template>
      </el-table-column>
      <!-- <el-table-column :show-overflow-tooltip="true" label="总计量级" v-if="platForm=='437'">
        <template slot-scope="scope">
          <span>{{ scope.row.traTotalMetering ? scope.row.traTotalMetering : 0 }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :show-overflow-tooltip="true" label="目标量级" v-if="platForm=='437'">
        <template slot-scope="scope">
          <span>{{ scope.row.traTargetMetering ? scope.row.traTargetMetering : 0 }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        :show-overflow-tooltip="true"
        :label="type==263?'预估订单额':'预估数据'"
        min-width="100px"
      >
        <template slot-scope="scope">{{ moneyTrans(scope.row.trafficUserEstimateDataNums) }}</template>
      </el-table-column>
      <!-- <el-table-column :show-overflow-tooltip="true" label="结算系数" v-if="platForm=='437'">
        <template slot-scope="scope">
          <span>{{ moneyTrans(scope.row.settlementFactor) }}</span>
        </template>
      </el-table-column> -->
      <!-- <el-table-column :show-overflow-tooltip="true" label="优化因子2" v-if="platForm=='437'">
        <template slot-scope="scope">
          <span>{{ formatFloatMoney(scope.row.optimizationFactor) }}</span>
        </template>
      </el-table-column> -->
      <el-table-column
        :show-overflow-tooltip="true"
        :label="type==263?'比例':'单价'"
        min-width="100px"
      >
        <template slot-scope="scope">{{ moneyTrans(scope.row.outPrice) }}</template>
      </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        label="预估佣金"
        min-width="100px"
      >
        <template slot-scope="scope">{{ moneyTrans(scope.row.siteEstimateMoney) }}</template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="mt10">
      <el-pagination
        :key="pageInfo.currentPage"
        :current-page="pageInfo.currentPage"
        :page-size="pageInfo.limit"
        layout="total,sizes, prev, pager, next"
        :total="pageInfo.allCount"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </el-dialog>
</template>

<script>
import Setting from '@/settings.js'

var {pageConfig} = Setting
import {emptyTrans, formatMoney, formatDate} from '@/api/dataTrans.js'
import {estimateDetail} from "@/api/launch"
import {formatFloatMoney} from "../../../api/dataTrans";

export default {
  props: ["data", 'search', 'showTotal', 'platform'],
  data() {
    return {
      isShow: true,
      time: [],
      submitData: {
        start: '',
        end: ''
      },
      total: this.data,
      list: this.data.items,
      tableKey: 0,
      searchData: this.search,
      pageInfo: {
        limit: pageConfig['limit'],
        allCount: this.data.total,
        currentPage: 1,
        currentPageCount: 0,
        showEdit: false // 是否显示快捷编辑代码框
      },
      type: this.search.billingType,
      totalMoney: this.showTotal,
      platForm: this.platform,
      listLoading: false

    }
  },

  mounted() {
    console.log(JSON.stringify(this.search))
  },
  methods: {
    //关闭弹窗
    handleClose() {
      this.$emit("close", null)
    },
    queryData() {
      this.pageInfo.currentPage = 1
      this.getDetail()
    },
    getDetail(val) {
      var parmasList = {}
      if (this.time && this.time.length > 0) {
        parmasList.startTime = this.time[0]
        parmasList.endTime = this.time[1]
      } else {
        parmasList.startTime = null;
        parmasList.endTime = null;
      }
      estimateDetail({
        pageSize: this.pageInfo.limit,
        pageNo: this.pageInfo.currentPage,
        packageId: this.searchData.packageId,
        effectStartTime: formatDate(this.searchData.startTime),
        effectEndTime: formatDate(this.searchData.endTime),
        ...parmasList
      }).then(res => {
        if (res && res.code == 0) {
          this.list = res.data.items
          this.total = res.data
          this.totalMoney.currentData = this.$countCurrentPage("trafficUserEstimateDataNums", this.list)
          this.totalMoney.currentMoney = this.$countCurrentPage("siteEstimateMoney", this.list)
          this.pageInfo.allCount = res.data.total
        }
      })
    },
    moneyTrans(_val) {
      return formatMoney(_val)
    },
    resetSearch(formName) {
      this.time = []
      // this.submitData = this.$options.data().submitData
      this.getDetail()
    },
    emptyDeal(_val) {
      if (_val == '0') {
        return _val
      }
      return emptyTrans(_val)
    },
    formatFloatMoney(_val) {
      if (!_val && _val != '0') {
        return '--'
      }
      return formatFloatMoney(_val);
    },
    handleSizeChange(val) {
      this.pageInfo.limit = val
      this.getDetail()
    },
    handleCurrentChange(val) {
      this.pageInfo.currentPage = val
      this.getDetail()
    },
  }
}
</script>
<style scoped lang="scss">
/deep/ .el-dialog .el-dialog__body {
  font-size: 14px;
}

/deep/ .el-dialog__header .el-dialog__title {
  font-size: 16px;
}

/deep/ .el-date-editor .el-range__icon {
  line-height: 18px;
}
</style>
